var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapsable-card',{attrs:{"title":_vm.$t('app.general.title.retract'),"icon":"$retract","draggable":true,"layout-path":"dashboard.retract-card"}},[_c('retract')],1)}
var staticRenderFns = []

export { render, staticRenderFns }